
import React,{useEffect,useState} from 'react'
import {Modal,Form,Button,Alert} from 'react-bootstrap'
import ResetPassword from './resetPasswordFunction'

function PasswordResetPopUp(props){
    const [show ,setShow] = useState(props.show)
    const [email,setEmail] =useState(props.email!=null?props.email:"")
    const [success,setSuccess] = useState(false)
    const Hide = ()=>{
        setShow(false)
    } 
    const onChange = (event) =>{
        setEmail(event.target.value)
        
    }
    const handleReset =   async () =>{
        var resp =  await ResetPassword(email)
        if(resp.status){
            
            setSuccess(true)
            
        }
        else{
            alert(resp.error)
        }
    }
    return(
        <Modal show={props.show} onHide={props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Request password reset</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form >
                    <Form.Group>
                        <Form.Label>E-mail address:</Form.Label>
                        {props.email == null?<Form.Control type="email" onChange={onChange} disabled={success}/>:
                          <>
                              <br/>
                              {props.email}
                          </>
                        }
                    </Form.Group>
                </Form>
                {success && <Alert variant={"success"}>Password reset request has been sent to {email}</Alert>}
                
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleReset} >Reset Password</Button>
            </Modal.Footer>
        </Modal>
    )
}
PasswordResetPopUp.defaultProps = {
    email:null
}
export default PasswordResetPopUp;